import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';

export const templatePackages = document.createElement('template');

templatePackages.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="deployer-grid-content">
      <div class="deployer-grid">
        <gz-grid-view class="grid-wrapper">
          <div slot="no-results--additional-data">
            <gz-text id="packages-empty-state-text" fontSize="14"></gz-text>
          </div>
        </gz-grid-view>
      </div>
    </div>
    <gz-info-box class="info-box-style"></gz-info-box>
  </div>
`;
